import { render, staticRenderFns } from "./MeasureTable.vue?vue&type=template&id=4d9e887d&"
import script from "./MeasureTable.vue?vue&type=script&lang=js&"
export * from "./MeasureTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports